export default "__VITE_ASSET__D075hWXF__"